export const VendorReviewFormQuestions = [
	{
		key: 'area_responsavel',
		order: 1,
		label: 'Sua área / responsável pelo contrato',
		type: 'short_text',
		required: true,
	},
	{
		key: 'fornecedor_razao_social',
		order: 2,
		label: 'Nome ou razão social do fornecedor (e CNPJ, se tiver)',
		type: 'short_text',
		required: true,
	},
	{
		key: 'objeto_contratacao',
		order: 3,
		label: 'O que será contratado? (descreva em uma ou duas frases)',
		type: 'paragraph',
		required: true,
	},
	{
		key: 'tipo_contratacao',
		order: 4,
		label: 'Esta é uma nova contratação ou uma renovação?',
		type: 'single_select',
		required: true,
		options: ['Nova contratação', 'Renovação de contrato existente'],
	},
	{
		key: 'duracao_contrato',
		order: 5,
		label: 'Duração do contrato',
		type: 'single_select',
		required: true,
		options: [
			'Pontual (serviço único)',
			'Até 12 meses',
			'Plurianual (mais de 12 meses)',
		],
	},
	{
		key: 'valor_contrato',
		order: 6,
		label:
			'Valor do contrato — se não souber o valor exato, escolha a faixa aplicável',
		type: 'single_select',
		required: true,
		options: [
			'Até R$ 120 mil (ou compra pontual, até 2 pagamentos/ano)',
			'Entre R$ 120 mil e R$ 600 mil',
			'Entre R$ 600 mil e R$ 6 milhões',
			'Acima de R$ 6 milhões',
		],
	},
	{
		key: 'pagamento_antecipado',
		order: 7,
		label: 'Haverá adiantamento ou pagamento antecipado?',
		type: 'single_select',
		required: true,
		options: ['Não', 'Sim'],
	},
	{
		key: 'acesso_dados',
		order: 8,
		label:
			'O fornecedor vai acessar ou tratar dados de clientes ou dados pessoais?',
		type: 'single_select',
		required: true,
		options: [
			'Não acessa nenhum dado',
			'Sim, dados comuns (cadastro, contato)',
			'Sim, dados sensíveis (financeiros, documentos, informações de crédito de clientes)',
			'Não sei',
		],
	},
	{
		key: 'acesso_sistemas',
		order: 9,
		label: 'O fornecedor vai acessar nossos sistemas ou se integrar a eles?',
		type: 'single_select',
		required: true,
		options: [
			'Não',
			'Sim, acesso pontual',
			'Sim, integração contínua',
			'Não sei',
		],
	},
	{
		key: 'armazenamento_dados',
		order: 10,
		label:
			'O fornecedor armazena nossos dados ou presta serviço de nuvem/hospedagem/processamento de dados?',
		type: 'single_select',
		required: true,
		options: ['Não', 'Sim', 'Não sei'],
	},
	{
		key: 'presenca_escritorio',
		order: 11,
		label:
			'A equipe do fornecedor virá ao nosso escritório prestar serviço presencial?',
		type: 'single_select',
		required: true,
		options: [
			'Não',
			'Sim, pontualmente (até um dia)',
			'Sim, por mais de um dia',
		],
	},
	{
		key: 'criticidade_substituto',
		order: 12,
		label:
			'Se esse fornecedor parar de atender, a operação para? Existe outro no mercado?',
		type: 'single_select',
		required: true,
		options: [
			'Não é crítico — dá para operar sem ele',
			'É importante, mas há alternativas',
			'É crítico e não há substituto fácil',
		],
	},
	{
		key: 'vinculo_pessoal',
		order: 13,
		label:
			'Algum colaborador da SuperSim tem vínculo pessoal, familiar ou societário com esse fornecedor?',
		type: 'single_select',
		required: true,
		options: ['Não', 'Sim', 'Não sei'],
	},
	{
		key: 'situacoes_aplicaveis',
		order: 14,
		label: 'Alguma destas situações se aplica? (marque todas que valerem)',
		type: 'multi_select',
		required: true,
		options: [
			'O fornecedor terá contato com órgão ou agente público em nome da SuperSim',
			'Sei que há político ou agente público, ou familiar próximo (cônjuge, companheiro, enteado ou parente até 2º grau: pais, filhos, irmãos, avós, netos) de político ou agente público entre os sócios/donos',
			'O fornecedor tem operação ou sócios fora do Brasil',
			'O fornecedor atua em setor regulado, ou lida diretamente com o fluxo financeiro da operação (ex.: intermediação, custódia, liquidação, cobrança ou repasse de valores em nome da SuperSim)',
			'Já ouvi ou li algo negativo sobre a reputação do fornecedor',
			'Nenhuma das anteriores',
		],
	},
	{
		key: 'paises_fora_brasil',
		order: 15,
		label:
			'Se marcou "operação ou sócios fora do Brasil": em qual(is) país(es)?',
		type: 'short_text',
		required: false,
		conditional: {
			dependsOn: 'situacoes_aplicaveis',
			showWhenIncludes: 'O fornecedor tem operação ou sócios fora do Brasil',
		},
	},
	{
		key: 'observacoes',
		order: 16,
		label: 'Observações',
		type: 'paragraph',
		required: false,
	},
]
